import { render, staticRenderFns } from "./InitPasswordDialog.vue?vue&type=template&id=9bec0df4&scoped=true&"
import script from "./InitPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./InitPasswordDialog.vue?vue&type=script&lang=js&"
import style0 from "./InitPasswordDialog.vue?vue&type=style&index=0&id=9bec0df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bec0df4",
  null
  
)

component.options.__file = "InitPasswordDialog.vue"
export default component.exports